import { TemplateEntityStepV1beta3, TemplateParametersV1beta3 } from '@backstage/plugin-scaffolder-common';
import { JsonValue } from '@backstage/types';

export const UNSUPPORTED_FIELDS = [
  'GithubRepoUniqueFieldExtension',
  'LowerCaseFieldExtension',
  'GithubTeamFieldExtension',
];

export const UNSUPPORTED_ACTIONS = ['fetch:yamlify', 'fetch:spawn'];

export const UNSUPPORTED_TEMPLATE_MESSAGE = `Code-spawn, templates using the actions: ${JSON.stringify(UNSUPPORTED_ACTIONS)}, or the fields: ${JSON.stringify(UNSUPPORTED_FIELDS)} are deprecated and will not work.`;

type ScaffolderTemplateLike = {
  metadata?: {
    title?: string;
    name?: string;
  };
  spec?: {
    steps?: TemplateEntityStepV1beta3[];
    parameters?: TemplateParametersV1beta3 | TemplateParametersV1beta3[];
  };
};

const hasUnsupportedAction = (step: TemplateEntityStepV1beta3) =>
  UNSUPPORTED_ACTIONS.includes(step.action.trim());

const isJsonObject = (
  value: JsonValue | undefined,
): value is Record<string, JsonValue> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const checkPropsForUnsupportedFields = (properties: JsonValue | undefined) =>
  isJsonObject(properties) &&
  Object.values(properties).some(prop => {
    const uiField = isJsonObject(prop) ? prop['ui:field'] : undefined;
    return typeof uiField === 'string' && UNSUPPORTED_FIELDS.includes(uiField.trim());
  });

const hasUnsupportedFields = (
  parameters?: TemplateParametersV1beta3 | TemplateParametersV1beta3[],
) => {
  if (parameters === undefined) {
    return false;
  }

  const steps = Array.isArray(parameters) ? parameters : [parameters];
  return steps.some(step => checkPropsForUnsupportedFields(step.properties));
};

export const isUnsupportedTemplate = (template: ScaffolderTemplateLike) =>
  !!template.spec?.steps?.some(hasUnsupportedAction) ||
  hasUnsupportedFields(template.spec?.parameters);

export const getTemplateDisplayName = (template: ScaffolderTemplateLike) =>
  template.metadata?.title ?? template.metadata?.name ?? 'This template';
